import { get, set } from "@totalsoft/react-state-lens";
import curry from "lodash.curry";

export const addPropertyPrefix = curry((prefix, fn, prop) => fn(`${prefix}.${prop}`));

export const onCheckBoxChange = (onPropertyChange) => (event) => onPropertyChange(event.target.checked);

const onSliderChange = (onPropertyChange, currentValue) => (event, newValue) => {
  if (newValue === 0) {
    onPropertyChange(newValue);
    return;
  }

  if (!newValue && !currentValue) return;

  if (!newValue) return;

  onPropertyChange(newValue);
};

export const onLensSliderChange = (lens) => (event, newValue) => {
  onSliderChange(lens |> set, lens |> get)(event, newValue);
};

export const onTextBoxChange = (onPropertyChange) => (event) => {
  return onPropertyChange(event.target.value);
};

export const onNumericTextFieldChange = (onPropertyChange) => (event) => {
  if (!event) onPropertyChange(0);
  else onPropertyChange(event);
};

export const onDynamicInputChange = (onPropertyChange) => (_, value) => onPropertyChange(value);
